// broadcast-statistics.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BroadcastStatistics, VoxtralBroadcastStatistics } from '../../models/broadcast-statistic';

// Passe das Interface an dein JSON an:
export interface BroadcastStatistic {
  id: string;
  title: string;
  status: string;
  editors: string[];
  bruttoDuration: number;
  createdAt: string;               // oder Date, wenn du mappen möchtest
  wavTranscriptCreatedAt: string;  // ...
  wavTranscriptRearrangedCreatedAt?: string | null;
  // ... weitere Felder
}

@Injectable({
  providedIn: 'root'
})
export class BroadcastStatisticsService {

  // am besten aus environment.ts holen
  private readonly baseUrl = environment.API_Base;

  constructor(private http: HttpClient) {}

  /**
   * null bei 204 No Content — so antwortet das Backend, wenn die Abfrage
   * null liefert (bis 2026-09-29 für jeden Monat mit einem unlesbaren
   * Whisper-Transkript).
   */
  getBroadcastStatistics(
    startDateInclusive: Date,
    endDateExclusive: Date,
    channelFilter: string
  ): Observable<BroadcastStatistics | null> {

    const url = `${this.baseUrl}/broadcast/broadcast-statistics`;

    return this.http.get<BroadcastStatistics | null>(url, {
      params: this.rangeParams(startDateInclusive, endDateExclusive, channelFilter)
    });
  }

  /**
   * 2026-08-24 — Voxtral-Tab der Statistikseite. Gleicher Zeitraum-/Sender-
   * Filter wie oben; die Zeilen folgen den Regeln aus
   * scripts/export_voxtral_broadcasts.sh (gelaufene Sessions plus die nur
   * geplanten, damit Ausfälle sichtbar bleiben). null bei 204 No Content.
   */
  getVoxtralStatistics(
    startDateInclusive: Date,
    endDateExclusive: Date,
    channelFilter: string
  ): Observable<VoxtralBroadcastStatistics | null> {

    const url = `${this.baseUrl}/broadcast/voxtral-statistics`;

    return this.http.get<VoxtralBroadcastStatistics | null>(url, {
      params: this.rangeParams(startDateInclusive, endDateExclusive, channelFilter)
    });
  }

  private rangeParams(startDateInclusive: Date, endDateExclusive: Date, channelFilter: string): HttpParams {
    return new HttpParams()
      .set('startDateInclusive', this.formatDate(startDateInclusive))
      .set('endDateExclusive', this.formatDate(endDateExclusive))
      .set('channelFilter', channelFilter);
  }

  /** yyyy-MM-dd (lokal, ohne Zeitanteil) */
  private formatDate(date: Date): string {
    const year  = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 1–12
    const day   = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
}
